import { combineEpics } from 'redux-observable'
import { combineReducers } from 'redux-immutable'
import { routerReducer } from 'react-router-redux'
import ordersReducer, {
  fetchOrdersEpic,
  fetchOrderLinesEpic,
  createOrdersEpic,
  subscribeOrdersEpic,
  addOrderLineEpic,
  saveOrderEpic,
  editOrderEpic,
  deleteOrderEpic,
  saveOrderLineEpic,
  setOrderLineStatusEpic,
  payOrderEpic,
  editOrderLineEpic,
  cancelOrderLineEpic,
  fetchOrdersSuccess,
} from './modules/ordersDuck'
import teamsReducer, { fetchTeamsEpic, fetchTeamsSuccess } from './modules/teamsDuck'
import productsReducer, { fetchProductsEpic, fetchProductsSuccess } from './modules/productsDuck'
import uiReducer from './modules/uiDuck'
import { Observable } from 'rxjs/Observable'

import { apolloClient } from './apolloClient'

const FETCH_INITIAL_DATA_REQUEST = 'ROOT/FETCH_INITIAL_DATA_REQUEST'

export const fetchInitialDataRequest = () => ({type: FETCH_INITIAL_DATA_REQUEST})

//import { REHYDRATE } from 'redux-persist-immutable/constants'
//import { REHYDRATE } from 'redux-persist/constants'//NO

//One of the main reasons to extract the rootReducer to an independent
//file is to enable webpack hot module replacement for reducers

const combinedReducer = combineReducers({
  ordersStore: ordersReducer,
  teamsStore: teamsReducer,
  productsStore: productsReducer,
  uiStore: uiReducer,
  router: routerReducer,// Add the reducer to your store on the `router` key
  apollo: apolloClient.reducer(),

})

function crossSliceReducer (state, action) {
  switch (action.type) {
    case FETCH_INITIAL_DATA_REQUEST: {
      return state
        .setIn(['ordersStore', 'isLoading'], true)
        .setIn(['teamsStore', 'isLoading'], true)
        .setIn(['productsStore', 'isLoading'], true)
    }
    //case REHYDRATE:
    /*var incoming = action.payload.myReducer
     if (incoming) return { ...state, ...incoming, specialKey: processSpecial(incoming.specialKey) }*/
    //console.log('REHIDRATANDO ....');
    // return state

    default:
      return state
  }

}

export const rootReducer = (state, action) => {

  const intermediateState = combinedReducer(state, action)
  const finalState = crossSliceReducer(intermediateState, action)
  return finalState
}


const handleApiError = error => {
          console.log('error', error)
          return Observable.of({
            type: 'API_ERROR',
            payload: error,
            error: true
          })
        }

const fetchInitialDataEpic = (action$, store, { getInitialData }) =>
  action$.ofType(FETCH_INITIAL_DATA_REQUEST)
    .mergeMap(action => {
        return getInitialData()
          .concatMap(response => {
            return([
            fetchTeamsSuccess(response.teams), 
            fetchProductsSuccess(response.products), 
            fetchOrdersSuccess(response.orders), 
          ])})
          .catch(handleApiError)
    })

export const rootEpic = combineEpics(
  fetchOrdersEpic,
  fetchOrderLinesEpic,
  subscribeOrdersEpic,
  fetchTeamsEpic,
  fetchProductsEpic,
  createOrdersEpic,
  payOrderEpic,
  addOrderLineEpic,
  saveOrderLineEpic,
  setOrderLineStatusEpic,
  saveOrderEpic,
  editOrderEpic,
  editOrderLineEpic,
  cancelOrderLineEpic,
  deleteOrderEpic,
  fetchInitialDataEpic,
)



// WEBPACK FOOTER //
// ./src/redux/rootRedux.js